import React from 'react';
import { Pagination, PaginationItem, PaginationLink, PaginationProps } from 'reactstrap';
import { pageButtonRanges } from '~/lib/helper/PagingHelper';
import { Link } from 'react-router-dom';

type PageLinksProps = PaginationProps & {
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
    urlTemplate: (page: number, itemsPerPage: number) => string;
};

export class PageLinks extends React.Component<PageLinksProps> {
    render() {
        const { currentPage, itemsPerPage, totalItems, urlTemplate, ...paginationProps } = this.props;
        const lastPage = Math.ceil(totalItems / itemsPerPage);
        const pageCount = lastPage;

        if (pageCount < 1) return null;

        const ranges = pageButtonRanges(currentPage, pageCount);

        return (
            <Pagination {...paginationProps}>
                <PaginationItem disabled={currentPage < 2}>
                    <PaginationLink tag={Link} previous to={urlTemplate(Math.max(currentPage - 1, 1), itemsPerPage)} />
                </PaginationItem>
                {ranges.map((pages, rangeIdx) => (
                    <React.Fragment key={pages[0]}>
                        {rangeIdx > 0 && (
                            <PaginationItem key="sep" className="px-1">
                                ...
                            </PaginationItem>
                        )}
                        {pages.map((page) => (
                            <PaginationItem key={page} active={currentPage === page}>
                                <PaginationLink tag={Link} to={urlTemplate(page, itemsPerPage)}>
                                    {page}
                                </PaginationLink>
                            </PaginationItem>
                        ))}
                    </React.Fragment>
                ))}
                <PaginationItem disabled={currentPage === lastPage}>
                    <PaginationLink
                        tag={Link}
                        next
                        to={urlTemplate(Math.min(currentPage + 1, lastPage), itemsPerPage)}
                    />
                </PaginationItem>
            </Pagination>
        );
    }
}
